import styled from '@emotion/styled';

export const ContextBubbleContainer = styled.div`
  position: relative;
  margin-left: 1rem;
`;

export const BubblePointerContainer = styled.div`
  position: absolute;
  top: 15px;
  left: -3px;
  z-index: 100;
`;

interface IBubbleContentContainerProps {
  postitionLeft: number;
}
export const BubbleContentContainer = styled.div<IBubbleContentContainerProps>`
  position: absolute;
  left: ${(props) => props.postitionLeft}px;
  top: 22px;
  background-color: #51585a;
  color: white;
  min-width: 22.5rem;
  padding: 1rem;
  border-radius: 4px;
  z-index: 100;
`;
